export class InvestoridModel {
cmbInvestorId: string;
setValue(res){
if(res){
if(res['cmbInvestorId']){this.cmbInvestorId = res['cmbInvestorId'];}
}
}
}